import React from "react";
import { useSelector, useDispatch } from "types/store";
import { isEnabled } from "utils/featureFlags";
import { LineInput } from "components/Inputs/LineInput";
import LabeledToggle from "components/Inputs/Toggle/Toggle";
import { DEFAULT_MIN_EXPLORE_SAMPLE_SIZE } from "utils/insight/insights";
import styles from "./style.module.css";
import * as chatGPTReducer from "containers/ChatGPT/reducer";
import * as nextReducer from "containers/Next/NextReducer";
const SecurityOptions = ({ className, nextId, isChatResponse, disabled, isLoading, ...retProps }) => {
    const dispatch = useDispatch();
    const fieldsDisabled = Boolean(disabled || isLoading);
    const minimumValueCount = useSelector((state) => nextReducer.getMinimumValueCount(state, nextId));
    const updateMinimumValueCount = (val) => dispatch(nextReducer.updateMinimumValueCount(nextId, val));
    const useSecurityMasking = useSelector((state) => chatGPTReducer.getUseSecurityMasking(state));
    const updateUseSecurityMasking = (val) => dispatch(chatGPTReducer.updateUseSecurityMasking(val));
    const showRequestJSON = useSelector((state) => chatGPTReducer.getShowRequestJSON(state));
    const updateShowRequestJSON = (val) => dispatch(chatGPTReducer.updateShowRequestJSON(val));
    const skipSecurityConfirm = useSelector((state) => chatGPTReducer.getSkipSecurityConfirm(state));
    const updateSkipSecurityConfirm = (val) => dispatch(chatGPTReducer.updateSkipSecurityConfirm(val));
    return (React.createElement("div", { className: styles.securityOptionsWrapper + " " + (className ? className : ""), ...retProps },
        React.createElement("div", { className: styles.securityOptionsTitle }, "Security Settings"),
        React.createElement("div", null,
            !isChatResponse && (React.createElement("div", null,
                React.createElement("div", { className: styles.chatSecurityItem },
                    React.createElement("div", null, "Confirm security settings before starting chat"),
                    React.createElement("div", { className: styles.chatSecurityToggle },
                        React.createElement(LabeledToggle, { style: { display: "block" }, checked: !skipSecurityConfirm, onChange: () => updateSkipSecurityConfirm(!skipSecurityConfirm), disabled: fieldsDisabled, isAibleColors: true }))))),
            React.createElement("div", { className: styles.chatSecurityItem },
                React.createElement("div", null, "Filter out values where the count is less than "),
                React.createElement("div", { className: styles.chatSecurityInput },
                    React.createElement(LineInput, { isSenseBox: true, inputStyle: { background: "#FFFFFF" }, value: minimumValueCount ?? DEFAULT_MIN_EXPLORE_SAMPLE_SIZE, isDisabled: fieldsDisabled, onChange: (val) => {
                            const v = Number(val);
                            if (!isNaN(v)) {
                                updateMinimumValueCount(v);
                            }
                        }, type: "integer" })),
                isEnabled("chat-aible-sql-queries") && (React.createElement("div", { style: {
                        color: "#7E7D9A",
                        marginLeft: "10px"
                    } }, "This only applies to data model insights (not SQL queries)"))),
            !isChatResponse && (React.createElement("div", { className: styles.chatSecurityItem },
                React.createElement("div", null, "Show what was sent with each prompt"),
                React.createElement("div", { className: styles.chatSecurityToggle },
                    React.createElement(LabeledToggle, { style: { display: "block" }, checked: showRequestJSON, onChange: () => updateShowRequestJSON(!showRequestJSON), isAibleColors: true, disabled: fieldsDisabled })))))));
};
export default SecurityOptions;
